export interface BannerItem {
    title: string;
    image: string;
    description: string;
    link: string;
    color: string;
    scale?: number;
}

export const projectsItems: BannerItem[] = [
    {
        title: "BONKrewards",
        image: require("../assets/carousel/BONKRewards.svg").default,
        description: "Rewards site for those who lock their BONK",
        link: "https://bonkrewards.com/",
        color: "#ffd253",
    },
    {
        title: "BONKmark",
        image: require("../assets/carousel/BONKMark.svg").default,
        description: "Onboarding your loved ones easily onchain with BONK's version of e-card",
        link: "https://bonkmark.com/",
        color: "#ffd253",
    },
    {
        title: "Bonk Scooper",
        image: require("../assets/carousel/BONKScooper.svg").default,
        description: "Transfer wallets tokens into BONK and closing unused accounts",
        link: "https://www.pooperscooper.app/",
        color: "#ffd253",
    },
    {
        title: "BONKlive",
        image: require("../assets/carousel/BONKLive.svg").default,
        description: "Curated Token Launchpad",
        link: "https://bonk.live/",
        color: "#ffd253",
    },
    {
        title: "BONKbets",
        image: require("../assets/carousel/BONKBets.svg").default,
        description: "Sportsbetting website / most trusted gaming platform",
        link: "https://bonkbets.io/",
        color: "#ffd253",
    },
];

export const ART_ITEMS: BannerItem[] = [
    {
        title: "MoonWalk",
        image: require("../assets/banner/art/Moonwalk.svg").default,
        description: "Moonwalk turns daily steps into a challenge—hit your goal to keep your deposit.",
        link: "https://moonwalk.fit",
        color: "#ffd253",
        scale: 0.6,
    },
    {
        title: "EXCHANGE ART",
        image: require("../assets/banner/art/ExchangeArt.svg").default,
        description: "Exchange Art is a curated NFT marketplace for artists and collectors.",
        link: "https://exchange.art/",
        color: "#ffd253",
        scale: 0.7,
    },
    {
        title: "BONK ART MASTERS",
        image: require("../assets/banner/art/BAM.svg").default,
        description: "BONK Art Master features our iconic BONK shiba inu through the eyes of talented artists on-chain.",
        link: "https://exchange.art/bonk-galleries/nfts",
        color: "#ffd253",
        scale: 0.6,
    },
    {
        title: "LETSBONK",
        image: require("../assets/banner/art/letsbonk-logo.svg").default,
        description: "LETSBONK is a community run launch pad for meme tokens.",
        link: "https://letsbonk.fun/",
        color: "#ffd253",
        scale: 0.6,
    },
    {
        title: "BONK FOR PAWS",
        image: require("../assets/banner/art/b4p.svg").default,
        description: "BONKforPaws leverages the BONK community to fund meaningful charitable projects.",
        link: "https://www.bonkforpaws.org/",
        color: "#ffd253",
        scale: 0.6,
    },
];
